if (!window.reaCardCarouselDragInit) {
  window.reaCardCarouselDragInit = true;

  // Native overflow-x:auto + scroll-snap already gives real touch swipe on
  // mobile for free (see card-product.liquid) — this only adds
  // click-and-drag support for mouse pointers, which a plain scrollable div
  // doesn't get natively in any browser. Scoped strictly to pointerType
  // 'mouse' so touch/pen input is left entirely to native scrolling.
  //
  // All listeners are registered explicitly passive and never call
  // preventDefault, by construction — not just "shouldn't matter because
  // pointerType is checked first". A non-passive listener (the default for
  // pointer events, unlike touchstart/touchmove) can make the browser wait
  // on the main thread before it decides whether a touch is allowed to
  // scroll, regardless of what the handler's runtime logic actually does.
  // Passive:true removes that ambiguity at the browser level entirely, so
  // touch scrolling can never be blocked by this script no matter what the
  // handler body does. The native ghost-image-drag suppression for mouse is
  // handled by CSS (-webkit-user-drag/user-select in base.css) instead of a
  // JS preventDefault, so no listener here needs to be non-passive at all.
  let active = null;
  let suppressNextClick = false;
  const DRAG_THRESHOLD = 5;

  document.addEventListener(
    'pointerdown',
    (event) => {
      if (event.pointerType !== 'mouse') return;
      const slider = event.target.closest('.card__media-slider');
      if (!slider) return;
      active = {
        slider,
        startX: event.clientX,
        startScrollLeft: slider.scrollLeft,
        moved: false,
      };
      slider.style.scrollSnapType = 'none';
      slider.classList.add('card__media-slider--dragging');
    },
    { passive: true }
  );

  document.addEventListener(
    'pointermove',
    (event) => {
      if (!active) return;
      const dx = event.clientX - active.startX;
      if (Math.abs(dx) > DRAG_THRESHOLD) active.moved = true;
      // scrollTo (not direct .scrollLeft assignment) — assigning .scrollLeft
      // directly is unreliable on elements with scroll-snap-type active, even
      // with snap disabled for the drag; scrollTo/scrollBy consistently work.
      active.slider.scrollTo({
        left: active.startScrollLeft - dx,
        behavior: 'instant',
      });
    },
    { passive: true }
  );

  const endDrag = () => {
    if (!active) return;
    // Each slide has its own product link (base.css/card-product.liquid) so
    // native touch drag-vs-tap works for free via the browser's own
    // suppress-the-click-after-a-pan behavior. Mouse doesn't get that for
    // free here, because the "scrolling" is us calling scrollTo() by hand,
    // not a real browser-recognized pan gesture — so without this, dragging
    // the carousel with a mouse would also navigate to the product on
    // mouseup. Only set when an actual drag happened; a plain click is
    // untouched.
    if (active.moved) suppressNextClick = true;
    active.slider.style.scrollSnapType = '';
    active.slider.classList.remove('card__media-slider--dragging');
    active = null;
  };

  document.addEventListener('pointerup', endDrag, { passive: true });
  document.addEventListener('pointercancel', endDrag, { passive: true });

  // Suppress the native ghost-image drag so it doesn't fight the custom drag
  // (mouse-only in every browser — touch doesn't trigger HTML5 dragstart).
  document.addEventListener('dragstart', (event) => {
    if (event.target.closest('.card__media-slider')) event.preventDefault();
  });

  // Capture phase, so this runs before the per-slide link's own navigation
  // and before Dawn's onButtonClick/linkToSlide — two unrelated jobs live
  // here on purpose since both only make sense scoped to this one click:
  // (1) consume the drag-suppression flag set above, (2) stop arrow/dot
  // clicks (which Dawn's handlers already preventDefault, but not
  // stopPropagation) from bubbling to whatever wraps the card.
  document.addEventListener(
    'click',
    (event) => {
      if (suppressNextClick) {
        suppressNextClick = false;
        if (event.target.closest('.card__media-slide a')) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }
      }
      if (event.target.closest('.card__media-carousel .slider-button, .card__media-carousel .slider-counter__link')) {
        event.stopPropagation();
      }
    },
    true
  );
}
